import { render, staticRenderFns } from "./pubPaperMedia.vue?vue&type=template&id=268c50ce&scoped=true"
import script from "./pubPaperMedia.vue?vue&type=script&lang=js"
export * from "./pubPaperMedia.vue?vue&type=script&lang=js"
import style0 from "./pubPaperMedia.vue?vue&type=style&index=0&id=268c50ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268c50ce",
  null
  
)

export default component.exports